export default __webpack_public_path__ + "images/DE.3253cf9.png";